import React, { ChangeEvent, FC, useContext, useState } from 'react';
import { LoadingButton } from '@mui/lab';

import { Box, FormHelperText, TextField, Typography } from '@mui/material';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'src/store';
import { login } from 'src/Areas/Genericos/GE/slices/account';
import { DoisFatoresContext } from 'src/Areas/Genericos/GE/contexts/DoisFatoresContext';
import { useSettings } from '@cigam/template/dist/hooks/useSettings';
import { numberRegex } from 'src/Areas/Genericos/GE/global/constants/regex';

const CodigoAdministrador: FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { settings } = useSettings();
  const { historyNavigation } = useSelector(state => state);
  const { username, password } = useContext(DoisFatoresContext);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [codigoVerificacao, setCodigoVerificacao] = useState('');
  const portalAtivo = settings.activePortals[0];

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === '' || numberRegex.test(event.target.value)) {
      setCodigoVerificacao(event.target.value);
    }
    setErro('');
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await dispatch(login(username, password, portalAtivo, codigoVerificacao));
      history.push(historyNavigation.pathname);
      setLoading(false);
    } catch {
      setErro('Código de verificação inválido.');
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h4" color="textPrimary">
        Autenticação em Duas Etapas
      </Typography>
      <Typography variant="body1" color="textPrimary" mt={2}>
        Solicite ao administrador do sistema um código de verificação para
        continuar
      </Typography>
      <TextField
        sx={{ marginTop: 4, marginBottom: 4 }}
        fullWidth
        autoFocus
        label="Inserir o código de verificação"
        margin="normal"
        name="codigoVerificacao"
        type="text"
        onChange={handleChange}
        value={codigoVerificacao}
        onKeyDown={event => {
          if (event.key === 'Enter') handleSubmit();
        }}
        InputProps={{
          inputProps: {
            style: { textAlign: 'center' },
            maxLength: 6,
          },
        }}
      />
      <LoadingButton
        sx={{ marginTop: 4 }}
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        loading={loading}
        onClick={handleSubmit}
      >
        Confirmar
      </LoadingButton>
      {erro && (
        <Box mt={2}>
          <FormHelperText error>{erro}</FormHelperText>
        </Box>
      )}
    </Box>
  );
};
export default CodigoAdministrador;
